module.exports = __webpack_public_path__ + "static/best-relationship-small-business-2022-095e2421cc2a1c826a83d7c623a85318.svg";